{
  "common" : {
    "px" : "px",
    "px_uppercase" : "PX",
    "seconds" : "Sekunden",
    "other" : "-- Andere --",
    "customFieldExistsError" : "Benutzerdefiniert Feld mit diesem Namen existiert bereits",
    "uniqueKeyNotUniqueError" : "Dieser Schlüssel- ist nicht eindeutig",
    "save" : "Speichern",
    "saving" : "Speichern",
    "typeAnOption" : "Geben Sie eine Option ein",
    "unsaved" : "Nicht gespeichert",
    "noSubmissionsFound" : "Keine Einreichungen gefunden",
    "sortBy" : "Sortieren nach",
    "clearAll" : "Alles löschen",
    "submitSurvey" : "Umfrage absenden",
    "select" : "Auswählen",
    "data" : "Daten",
    "disqualifyAfterSubmitLower" : "Nach dem Absenden disqualifizieren",
    "errorRetryAgain" : "Fehler – versuchen Sie es erneut",
    "bubbleRadioStyleImageAlt" : "Bubble-Radio-Stil",
    "standardRadioStyleImageAlt" : "Standard-Radio-Stil",
    "recurringFrequency" : {
      "once" : "Einmal",
      "daily" : "Täglich",
      "weekly" : "Wöchentlich",
      "monthly" : "Monatlich",
      "yearly" : "Jährlich"
    },
    "yes" : "Ja",
    "no" : "Nein",
    "updated" : "Aktualisiert",
    "new" : "Neu",
    "title" : "Titel",
    "openSettings" : "Einstellungen öffnen",
    "cloneField" : "Feld klonen",
    "removeField" : "Feld entfernen",
    "description" : "Beschreibung",
    "cannotAddThisField" : "Dieses Feld kann nicht hinzugefügt werden",
    "overallOnly" : "Nur Gesamt",
    "nextSlideDefault" : "Nächste Folie (Standard)",
    "nextQuestion" : "Nächste Frage",
    "searchAddress" : "Adresse suchen",
    "recurringDonation" : "Wiederkehrende Spende",
    "recurringDonationDay" : "Wiederkehrende Spende 1 Tag",
    "recurringDonationWeek" : "Wiederkehrende Spende 1 wöchentlich",
    "recurringDonationMonth" : "Wiederkehrende Spende 1 Monat",
    "recurringDonationYear" : "Wiederkehrende Spende 1 Jahr",
    "integrate" : "Integrieren",
    "preview" : "Vorschau",
    "back" : "Zurück",
    "alert" : "Benachrichtigung",
    "proceed" : "Fortfahren",
    "confirm" : "Bestätigen",
    "cancel" : "Stornieren",
    "delete" : "Löschen",
    "embed" : "Einbinden",
    "link" : "Link",
    "linkModal" : {
      "title" : "Link einfügen",
      "urlLabel" : "URL",
      "urlPlaceholder" : "https://www.beispiel.de",
      "invalidUrl" : "URL ist ungültig"
    },
    "iframeEmbed" : "Iframe Einbetten",
    "styles" : "Stile",
    "options" : "Optionen",
    "quickAdd" : "Schnelles Hinzufügen",
    "customFields" : "Benutzerdefinierte Felder",
    "addObjectFields" : "Objektfelder hinzufügen",
    "personalInfo" : "Persönliche Informationen",
    "contactInfo" : "Kontaktdaten",
    "submit" : "Absenden",
    "address" : "Adresse",
    "customized" : "Kundenspezifisch",
    "layout" : "Layout",
    "showLabel" : "Label anzeigen",
    "showImage" : "Bild anzeigen",
    "imageLayout" : "Bild-Inhaltliche Ausrichtung",
    "imageLayoutSettings" : "Bild Inhaltliche Ausrichtung Konfig",
    "imageLayoutMode" : "Bild Inhaltliche Ausrichtung-Modus",
    "surveyDefault" : "Standardumfrage",
    "independent" : "Unabhängig",
    "image" : "Bild",
    "desktop" : "Desktop",
    "mobile" : "Mobil",
    "desktopImage" : "Desktop-Bild",
    "mobileImage" : "Mobil-Bild",
    "uploaded" : "Hochgeladen",
    "changeImage" : "Bild ändern",
    "uploadImage" : "Bild hochladen",
    "remove" : "Entfernen",
    "background" : "Hintergrund",
    "buttonBackground" : "Hintergrund der Schaltfläche",
    "fontColour" : "Schriftart",
    "textFontColour" : "Textschriftfarbe",
    "subTextFontColour" : "Schriftfarbe des Subtextes",
    "selectThemes" : "Auswählen Thema",
    "selectOne" : "Einen auswählen",
    "enableIcon" : "Symbol aktivieren",
    "iconType" : "Symboltyp",
    "iconPlacement" : "Symbolplatzierung",
    "filled" : "Ausgefüllt",
    "textOnly" : "Nur Textkörper",
    "border" : "Abgrenzung",
    "borderType" : "Rahmen-Typ",
    "px" : "px",
    "cornerRadius" : "Eckenradius",
    "width" : "Breite",
    "padding" : "Innenabstand",
    "top" : "Top",
    "bottom" : "Unten",
    "left" : "Links",
    "right" : "Rechts",
    "center" : "Zentrum",
    "default" : "Standard",
    "formDefault" : "Standardformular",
    "shadow" : "Schatten",
    "color" : "Farbe",
    "horizontal" : "Horizontal",
    "vertical" : "Vertikal",
    "blur" : "Verwischen",
    "spread" : "Verbreiten",
    "fieldStyle" : "Feldstil",
    "fontColor" : "Schriftfarbe",
    "inputTextFillColor" : "Füllfarbe des Eingabetextes",
    "inputTextColor" : "Farbe des Eingabetextes",
    "primaryColor" : "PRIMÄRE Farbe",
    "primaryColorTooltip" : "Steuert die Farbe für den Hover-Zustand und den dynamischen Land.",
    "inputTextColorTooltip" : "Steuert die Farbe des in Feedback Felder eingegebenen Texts.",
    "mapPrimaryColorToButtonColor" : "Map PRIMÄRE Farbe zu Schaltfläche Farbe",
    "label" : "Label",
    "fontFamily" : "Schriftfamilie",
    "size" : "Größe",
    "weight" : "Gewicht",
    "fontWeightTooltip" : "Anwendbar im Falle von Absätzen",
    "fontWeightOptions" : {
      "thin" : "100 – Dünn",
      "extraLight" : "200 - Extra Light",
      "light" : "300 - Light",
      "normal" : "400 - Normal",
      "medium" : "500 – Mittel",
      "semiBold" : "600 – Halbfett",
      "bold" : "700 - Fett"
    },
    "placeholder" : "Platzhalter",
    "customCSS" : "Benutzerdefiniertes CSS",
    "backgroundImage" : "Hintergrundbild",
    "headerImage" : "Header-Bild",
    "miscellaneous" : "Verschiedenes",
    "agencyBranding" : "Branding der Agentur",
    "imageUploadMessage" : "Klicke oder ziehe eine Bilddatei in diesen Bereich, um sie hochzuladen",
    "backgroundImageTooltipMessage" : "Das Hintergrundbild soll die gesamte Seite bedecken und einen optisch ansprechenden Hintergrund für das Formular bilden. Um das Hintergrundbild anzuzeigen, klicken Sie auf die Option Vorschau.",
    "headerImageTooltipMessage" : "Das Kopfbild ist so gestaltet, dass es die gesamte Breite des Formulars abdeckt und oben im Formular positioniert bleibt. Um das Header-Bild anzuzeigen, klicken Sie auf die Option Vorschau.",
    "onSubmit" : "Beim Absenden",
    "facebookPixelID" : "Facebook-Pixel-ID",
    "facebookPixelIDMessage" : "Ignorieren Sie dieses Feld, wenn Sie dieses Formular/diese Umfrage in einem Funnel verwenden möchten",
    "facebookPixelEvents" : "Facebook Pixel Events",
    "onpageView" : "Seitenansicht",
    "stickyContact" : "Angehefteter Kontakt",
    "stickyContactMessage" : "Speichert Kontaktdaten und füllt sie automatisch aus, wenn der Benutzer mit demselben Gerät und Browser zurückkehrt.",
    "fieldDescription" : "Beschreibung des Feldes",
    "fieldTitle" : "Feldtitel",
    "queryKey" : "Abfrageschlüssel",
    "querykeyTooltipMessage" : "Der Abfrageschlüssel, der als URL-Parameter zum Auffüllen dieses Felds verwendet werden kann",
    "required" : "Erforderlich",
    "hidden" : "Versteckt",
    "hiddenValue" : "Versteckter Wert",
    "enableCountryPicker" : "Länderauswahl aktivieren",
    "altText" : "Alt-Text",
    "optionImageAlt" : "Option image",
    "bannerAlt" : "banner",
    "avatarAlt" : "Avatar Name",
    "alignment" : "Alignment",
    "imageWidth" : "Bildbreite",
    "imageHeight" : "Bildhöhe",
    "logic" : "Logik",
    "pleaseInput" : "Bitte eingeben",
    "editHTML" : "HTML bearbeiten",
    "textStyle" : "Textstil",
    "subText" : "Subtext",
    "text" : "Text",
    "buttonStyle" : "Button-Stil",
    "fullWidth" : "Volle Breite",
    "htmlMessage" : "Das benutzerdefinierte HTML wird hier eingefügt",
    "htmlEditorHeader" : "BENUTZERDEFINIERTES JAVASCRIPT / HTML",
    "htmlEditorBodyMessage" : "Füge deinen Code hier ein",
    "scriptAdded" : "Script Added!",
    "sourceAdded" : "Source Added!",
    "yesSave" : "Ja, speichern",
    "cancelKeep" : "Abbrechen, Behalten",
    "done" : "Erledigt",
    "addElement" : "Element hinzufügen",
    "addUrlLike" : "Bitte fügen Sie gültige URLs wie",
    "doNotAddRelativePath" : "Fügen Sie keine relativen Pfade wie",
    "or" : "oder",
    "addCustomFields" : "Benutzerdefinierte Felder hinzufügen",
    "customFieldSearch" : "Suche nach Namen",
    "enterSourceValue" : "Quellwert eingeben",
    "shortLabel" : "Kurzbezeichnung",
    "shortLabelPlaceholder" : "Schriftart eine Kurzbezeichnung",
    "labelPlaceholder" : "eintippen eine Label ein",
    "fileUploadPlaceholder" : "Upload eine File hoch",
    "imagePlaceholder" : "Image",
    "fillValuesPlaceholder" : "Werte ausfüllen",
    "customCSSTooltip" : "Benutzerdefiniertes CSS hat Vorrang vor dem Formularstyling und den Themes und kann sich auf das Styling des Themes auswirken.",
    "fontFamilyTooltip" : "Builder unterstützt alle Arten von Schriftarten, falls Sie diese nicht in der Liste sehen können. Suchen Sie im Dropdown-Menü danach.",
    "useGDPRCompliantFont" : "GDPR-konforme Schriftart verwenden",
    "enableTimezone" : "Zeitzone aktivieren",
    "inputStyle" : "Eingabestil",
    "conditionalLogicAlertOnSubmit" : "Die bedingte Logik hat hier Vorrang vor der Nachricht / Weiterleitung",
    "conditionalLogicAlertOnShowHide" : "Die bedingte Logik hat hier Vorrang vor den versteckten Einstellungen",
    "placeholderFacebookPixelIdInput" : "Geben Sie die Facebook-Pixel-ID ein",
    "doNotShowMessage" : "Nicht mehr anzeigen",
    "creatingForm" : "Erstellt Ihr Formular...",
    "creatingSurvey" : "Erstellt Ihre Umfrage...",
    "creatingQuiz" : "Erstellt Ihr Quiz...",
    "errorCreatingForm" : "da war ein Fehler in Ihrem Formular erstellt. Bitte Erneut versuchen.",
    "errorCreatingSurvey" : "da war ein Fehler Erstellt Ihre Umfrage. Bitte Erneut versuchen.",
    "errorCreatingQuiz" : "da war ein Fehler Erstellt Ihr Quiz. Bitte Erneut versuchen.",
    "redirectMessage" : "Sie werden weitergeleitet zu:",
    "themes" : {
      "themes" : "Themen",
      "alertThemeMessage" : "Ein Wechsel des Themas führt zum Verlust aller aktuellen Stiländerungen.",
      "useTheme" : "Thema verwenden",
      "removeTheme" : "Thema entfernen"
    },
    "box" : "Kasten",
    "line" : "Linie",
    "message" : "Nachricht",
    "openUrl" : "Weiterleitung zu URL",
    "borderTypeList" : {
      "dotted" : "Gepunktet",
      "dashed" : "Gestrichelt",
      "solid" : "Einfarbig",
      "none" : "Keine"
    },
    "button" : "Schaltfläche",
    "emailNotification" : "E-Mail-Benachrichtigung",
    "emailNotificationSubheader" : "Erhalte eine E-Mail, wenn jemand dein Formular ausfüllt",
    "subject" : "Betreff",
    "emailTo" : "E-Mail (An)",
    "senderName" : "Absendername",
    "senderNameWarning" : "Ihr (Name des Unterkontos) wird hinzugefügt, wenn Sie das Feld leer lassen",
    "emailError" : "Mindestens eine E-Mail-Adresse ist erforderlich.",
    "emailTooltip" : "Die erste E-Mail-Adresse ist für das Feld „An“ bestimmt. Alle nachfolgenden E-Mail-Adressen werden in das Feld \"Cc\" aufgenommen.",
    "clear" : "Klären",
    "filter" : "Filter",
    "noResults" : "Keine Ergebnisse",
    "search" : "Suchen",
    "showNotificationsSettings" : "Benachrichtigungseinstellungen anzeigen",
    "emailServicePaid" : "Diese Funktion ist ein kostenpflichtiger Dienst, für den Gebühren auf der Grundlage Ihrer Nutzung anfallen.",
    "integration" : "Integration",
    "validation" : {
      "fieldRequired" : "Feld ist Erforderlich",
      "maxLengthExceeded" : "Max.. Länge überschritten ({max} Zeichen)"
    },
    "securityValidation" : {
      "title" : "Sicherheitsprobleme erkannt. Folgendes ist nicht erlaubt:",
      "cookieAccess" : "Cookie-Zugriff erkannt (document.cookie). Dies ist aus Sicherheitsgründen nicht gestattet.",
      "storageAccess" : "localStorage.getItem() – Das Lesen von localStorage ist nicht gestattet.",
      "evalUsage" : "Die Verwendung von eval() ist nicht erlaubt, da darüber beliebiger Code ausgeführt werden kann.",
      "dynamicFunction" : "Eine dynamische Funktionserstellung (new Function) ist aus Sicherheitsgründen nicht erlaubt.",
      "stringExecution" : "Die Übergabe von Strings an setTimeout/setInterval ist nicht gestattet, da dies zur Ausführung beliebigen Codes führen kann. Verwenden Sie stattdessen Funktionsreferenzen."
    },
    "products" : {
      "subscriptionBadge" : "Abonnement",
      "trialBadge" : "{days}-tägige kostenlose Testversion",
      "setupFee" : "Einmalige Einrichtungsgebühr",
      "quantity" : "Menge",
      "productImageAlt" : "Produktbild",
      "bumpIconAlt" : "Symbol für Zusatzoption"
    },
    "payment" : {
      "payments" : "Zahlungen",
      "connected" : "Verbunden",
      "connect" : "Verbinden",
      "liveModeOn" : "Live-Modus",
      "status" : "Status",
      "test" : "Test",
      "live" : "Live",
      "paymentFields" : "Zahlungsfelder",
      "suggestAnAmount" : "Einen Betrag vorschlagen",
      "recurringPayments" : "Wiederkehrende Zahlungen",
      "selectCurrency" : "Währung auswählen",
      "tagActiveBGColor" : "Aktive Tag-Farbe",
      "includeOtherAmount" : "Anderen Betrag einschließen",
      "footerInfo" : "Informationen zur Fußzeile",
      "paymentType" : "Zahlungsart",
      "sellProducts" : "Produkte verkaufen",
      "customAmount" : "Benutzerdefinierter Betrag",
      "collectPayment" : "Zahlung einziehen",
      "generalSettings" : "Allgemeine Felder",
      "securePayments" : "*100 % Sperren und sichere Zahlungen*",
      "error" : {
        "addMainProductFirst" : "Fügen Sie zuerst ein PRIMÄRE-Produkt hinzu",
        "priceNotFoundForBumpProduct" : "Preis für Bump-Produkt nicht gefunden",
        "productAlreadyAdded" : "Produkt bereits hinzugefügt"
      },
      "product" : {
        "addProduct" : "Produkt hinzufügen",
        "productSettings" : "Produkt-Einstellungen",
        "bumpTag" : "Zusatzoption",
        "settingsAria" : "Produkteinstellungen",
        "deleteAria" : "Produkt löschen",
        "selectProduct" : "Produkt auswählen",
        "editThisProduct" : "So bearbeiten Sie dieses Produkt",
        "clickHere" : "Hier klicken",
        "show" : "Anzeigen",
        "description" : "Beschreibung",
        "image" : "Bild",
        "layoutSettings" : "Layouteinstellungen",
        "singleColumn" : "Einzelne Säule",
        "twoColumn" : "Zwei Spalten",
        "threeColumn" : "Drei Spalten",
        "maxProductError" : "Maximal 20 Produkte sind in einem Formular erlaubt",
        "productSelectPlaceholder" : "Bitte wählen Sie ein Produkt aus",
        "orderConfirmation" : "Bestätigung der Bestellung",
        "orderConfirmationWarning" : "Die Bestellbestätigungsseite wird angezeigt, sobald die Zahlung erfolgreich abgeschlossen wurde",
        "quantity" : "Menge",
        "createProduct" : "Um ein Produkt zu erstellen",
        "noProductsAdded" : "Noch keine Produkte hinzugefügt",
        "productsWillShowHere" : "Sobald Sie Produkte einbeziehen, werden sie hier nach oben angezeigt",
        "chooseProductType" : "Auswählen Produkt eintippen",
        "mainProduct" : "PRIMÄRE Produkt"
      },
      "bumProduct" : {
        "price" : "Preis",
        "variant" : "Variante",
        "headline" : "Überschrift",
        "otoHeadline" : "OT Überschrift",
        "otoText" : "OT Textkörper",
        "enableImage" : "Bild Aktivieren",
        "imageMessage" : "Wir holen uns das Standard -Produktbild",
        "orUploadADifferentImage" : "Oder Upload ein anderes Bild hoch",
        "bumpProducts" : "Bump-Produkte",
        "bumpProduct" : "Bump-Produkt",
        "enableBump" : "Bump Aktivieren",
        "orderBumpStyle" : "Order Bump Stil",
        "classic" : "Klassisch",
        "modern" : "Hochwertig",
        "icon" : "Symbol",
        "bumpTemplate" : "Vorlage Auswählen",
        "highlightText" : "Hervorhebung Textkörper",
        "showPrice" : "Preis anzeigen",
        "bumpPriceColor" : "Bump Preis",
        "bumpIconColor" : "Bump- Symbol",
        "bumpBackgroundColor" : "Bump- Hintergrund",
        "highlightTextColor" : "Hervorhebung Textkörper",
        "headlineColor" : "Überschrift",
        "otoHeadlineColor" : "OT Überschrift",
        "otoTextColor" : "OT Textkörper",
        "bumpBorderColor" : "Bump Abgrenzung",
        "priceRequired" : "Preis ist erforderlich",
        "headlineRequired" : "Überschrift ist erforderlich",
        "otoHeadlineRequired" : "OTO-Überschrift ist erforderlich",
        "otoTextRequired" : "OTO-Text ist erforderlich",
        "bumpProductTooltip" : "Ein Klein Add-On, das während der Kasse angeboten wird, um Sortieren Wert zu multiplizieren. Der Kunde kann es mit einem Einzelperson Klick einbeziehen.",
        "templateOne" : "Vorlage 1",
        "templateTwo" : "Vorlage 2",
        "templateThree" : "Vorlage 3",
        "animationIcon" : {
          "none" : "Nichts",
          "arrow" : "Pfeil",
          "fire" : "Brand",
          "plus" : "Plus",
          "giftBox" : "Kasten",
          "timer" : "Countdown",
          "cracker" : "Clicker",
          "snack" : "Imbiss",
          "partyBalloon" : "Gruppe von Personen",
          "flash" : "Blende",
          "money" : "Währung",
          "spaceShuttle" : "Platz"
        }
      },
      "coupons" : {
        "coupons" : "Coupons",
        "enableCoupon" : "Coupon aktivieren",
        "couponAlignment" : "Coupon-Ausrichtung",
        "left" : "Links",
        "right" : "Rechts",
        "fullWidth" : "Volle Breite",
        "tooltipMessage" : "Legen Sie die Position der Couponeingabe aus den folgenden Typen fest"
      }
    },
    "addressSettings" : {
      "autoComplete" : "Adresse automatisch ausfüllen",
      "addressfields" : "Adressfelder",
      "placeholderSearch" : "Suche nach einer Adresse",
      "autoCompleteTooltip" : "Bietet die Möglichkeit zum Suchen und automatischen Ausfüllen von Adressen.",
      "streetAddress" : "Anschrift",
      "autoCompleteAddressTitle" : "Auto Beenden-Adresse",
      "newBadge" : "Neu",
      "defaultLabel" : "Anschrift",
      "searchPlaceholder" : "Suchen Adresse",
      "mandataorySearch" : {
        "title" : "Erforderlich, um die Anschrift in der Suchen Auswählen",
        "primaryText" : "Automatische Vervollständigung nur für die Anschrift",
        "secondaryText" : "Wenn aktiviert, wenn ein Benutzer mit dem Anschrift-Feld interagieren, Then muss er eine gültige Anschrift auswählen, um Fortfahren.",
        "secondaryText1" : "Wenn deaktiviert , können sie fortfahren, ohne eine Adresse in der Suchenleiste auszuwählen."
      }
    },
    "autoResponder" : "Automatische Antwort",
    "autoResponderSubheader" : "Sende eine automatische E-Mail an die Person, die das Formular absendet (die E-Mail enthält eine Kopie der Informationen, die sie in das Formular eingegeben hat)",
    "replyToEmail" : "Antwort auf E-Mail",
    "open" : "Offen",
    "won" : "Gewonnen",
    "lost" : "Verpasst",
    "abandon" : "Verlassen",
    "selectAPipeline" : "Pipeline auswählen",
    "stage" : "Schritt",
    "status" : "Status",
    "opportunityValue" : "Opportunitätswert",
    "createNewPipeline" : "Neue Pipeline erstellen",
    "editOpportunitySettings" : "Opportunity-Einstellungen bearbeiten",
    "contact" : "Kontakt",
    "opportunity" : "Gelegenheit",
    "business" : "Unternehmen",
    "add" : "Hinzufügen",
    "manage" : "Verwalten",
    "more" : "Mehr",
    "opportunityHeading" : "Wo möchten Sie, dass Ihre Chance aktualisiert wird?",
    "date" : {
      "dateSettings" : "Datumseinstellungen",
      "dateFormat" : "Datumsformat",
      "dateSeparator" : "Datumstrennzeichen",
      "dateFormatTooltipMessage" : "Wählen Sie ein Datumsformat aus. D steht für Tag, M für Monate und Y für Jahr",
      "dateSeparatorTooltipMessage" : "Wähle ein Trennzeichen, das Tag, Monat und Jahr im ausgewählten Datumsformat trennt",
      "disablePicker" : "Picker deaktivieren"
    },
    "restoreVersion" : "Version wiederherstellen",
    "versionHistory" : "Versionsverlauf",
    "errorMessage" : "Fehler, erneuter Versuch",
    "version" : "Version:",
    "currentVersion" : "Aktuelle Version",
    "messageStyling" : "Nachrichten-Styling",
    "validateEmailHeader" : "E-Mail validieren",
    "validateEmailDescription" : "Die Schaltfläche wird sichtbar, sobald der Benutzer seine E-Mail-Adresse eingibt. Diese Funktion soll Ihnen helfen, hochwertige Leads zu generieren.",
    "verifyEmail" : "E-Mail-Adresse bestätigen",
    "validatePhoneHeader" : "Telefon validieren",
    "validatePhoneDescription" : "Die Schaltfläche wird sichtbar, sobald der Benutzer sein Telefon betritt. Diese Funktion soll Ihnen helfen, hochwertige Leads zu generieren.",
    "verifyPhone" : "Rufnummer verifizieren",
    "validatePhoneWarning" : "Um die SMS-OTP-Verifizierung zu aktivieren, stellen Sie bitte sicher, dass Ihre Telefonnummer in Ihren Standorteinstellungen eingerichtet ist.",
    "addAnotherTnc" : "Weitere AGB hinzufügen",
    "tnc1" : "T & C 1",
    "tnc2" : "AGB 2",
    "deleteCaps" : "LÖSCHEN",
    "deleteConfirmation" : "Geben Sie zur Bestätigung das Wort LÖSCHEN ein",
    "marginPadding" : "Rand & Abstand",
    "style" : {
      "formLayoutType" : "Formulartyp",
      "layoutType" : "Layouttyp",
      "surveyType" : "Umfragetyp",
      "oneColumn" : "Eine Säule",
      "twoColumn" : "Zwei Spalten",
      "singleLine" : "Einzelzeile",
      "fieldWidth" : "Feldbreite",
      "labelAlignment" : {
        "labelAlignment" : "Etikettenausrichtung",
        "labelWidth" : "Etikettenbreite"
      },
      "fieldSpacing" : "Feldabstand",
      "imageFieldSpacing" : "Bild- & Feldabstand",
      "imageCornerRadius" : "Bild-Eckradius",
      "color" : "Farbe",
      "fontColor" : "Schriftfarbe",
      "inputBackgroundColor" : "Eingabe Hintergrundfarbe",
      "inputBorder" : "Feedback-Abgrenzung",
      "layout" : "Layout",
      "colorsAndBackground" : "Farben & Hintergrund",
      "imageLayout" : {
        "imageLayout" : "Bild Inhaltliche Ausrichtung",
        "showImage" : "Bild anzeigen",
        "image" : "Bild",
        "desktop" : {
          "topFixed" : "Top Fest",
          "leftCenter" : "Linkes Zentrum",
          "rightCenter" : "Rechtes Zentrum",
          "leftFixed" : "Links fixiert",
          "rightFixed" : "Rechts Fest",
          "background" : "Hintergrund"
        },
        "mobile" : {
          "header" : "Kopfzeile",
          "background" : "Hintergrund"
        }
      },
      "focusPoint" : {
        "title" : "Fokuspunkt",
        "reset" : "Zurücksetzen",
        "noImage" : "Es wurde kein Bild hochgeladen"
      },
      "advanceSettings" : "Erweiterte Einstellungen",
      "inputField" : "Eingabefeld",
      "borderWidth" : "Rahmenbreite",
      "borderColor" : "Rahmenfarbe",
      "borderStyle" : "Rahmenstil",
      "fontSize" : "Schriftgröße",
      "fontWeight" : "Schriftstärke",
      "labelColor" : "Etikettenfarbe",
      "placeholderColor" : "Farbe des Platzhalters",
      "shortLabelColor" : "Kurze Etikettenfarbe"
    },
    "replyToTooltip" : "Passen Sie die standardmäßige Antwort-E-Mail-Adresse an, indem Sie {'{'}{'{'}contact.email{'}'}{'}'} verwenden, um Antworten an den Kontakt zu ermöglichen, der das Formular sendet.",
    "content" : "Inhalt",
    "calculations" : "Berechnungen",
    "uploadOptions" : "Upload-Optionen",
    "opportunitySettingsWarning" : "Bitte richten Sie die Opportunity-Einstellungen ein, indem Sie auf die Schaltfläche „Opportunity-Einstellungen bearbeiten“ klicken.",
    "startValue" : "Startwert",
    "endValue" : "Endwert",
    "today" : "Heute",
    "thisWeek" : "Diese Woche",
    "last7Days" : "Letzte 7 Tage",
    "thisMonth" : "Dieser Monat",
    "last30Days" : "Letzte 30 Tage",
    "question" : "Frage",
    "createContactOnPartialSubmission" : "Kontakt bei teilweiser Übermittlung erstellen",
    "howItWorks" : "Wie funktioniert das?",
    "createContactOnPartialSubmissionDescription" : "Beenden Sie die Folie und klicken Sie auf \" Weiter \". Ein neuer Kontakt wird automatisch erstellt und gespeichert.",
    "swapWarningMessageSurvey" : "Das Bearbeiten oder Austauschen von Optionen wirkt sich auf dieses benutzerdefinierte Feld an allen Stellen aus, an denen das Feld verwendet wird. Sie kann auch die bedingte Logik zurücksetzen. ",
    "swapWarningMessageForm" : "Das Bearbeiten oder Austauschen von Optionen wirkt sich auf dieses benutzerdefinierte Feld an allen Stellen aus, an denen das Feld verwendet wird. ",
    "migrationWarningMessage" : "Diese Funktion wurde zur bedingten Umfragenlogik migriert.",
    "optionLabel" : "Label der Option",
    "calculationValue" : "Berechnungswert",
    "addOption" : "Option hinzufügen",
    "enableCalculations" : "Berechnungen aktivieren",
    "allowOtherOption" : "Andere Option zulassen",
    "productSelectionSubtext" : "Aktivieren Sie die Einzelperson oder mehrere Produktauswahl",
    "multi" : "Multi",
    "single" : "Einzelperson",
    "productSelectionHeading" : "Produkt",
    "spreadToColumns" : "Auf Spalten Verbreiten",
    "columns" : "Spalte",
    "customstyle" : "Stil",
    "standard" : "Standard",
    "bubble" : "Blase",
    "integratePopup" : {
      "title" : "Formular integrieren",
      "embedCode" : "Einbettungscode",
      "useInFunnelOrEmbedCode" : "Verwendung im Funnel/Embed-Code",
      "iframeEmbed" : "Iframe Einbinden",
      "layout" : {
        "title" : "Layouttyp einbetten",
        "description" : "Wählen Sie ein Layout aus, das in einen Funnel oder eine externe Website eingebettet werden soll",
        "allowMinimize" : "Minimieren zulassen",
        "minimizedTitlePlaceholder" : "Minimierter Titel",
        "leftAlignAlt" : "Linksbündig",
        "rightAlignAlt" : "Rechtsbündig"
      },
      "triggerType" : "Auslöser-Typ",
      "triggers" : {
        "seconds" : "Sekunden"
      },
      "activation" : {
        "title" : "Aktivierungsoptionen",
        "visit" : "besuchen"
      },
      "deactivation" : {
        "title" : "Deaktivierungsoptionen",
        "times" : "Mal"
      },
      "copyEmbedCode" : "Einbettungscode kopieren",
      "copyFormLink" : "Formularlink kopieren",
      "openFormLink" : "Formularlink öffnen",
      "invalidInput" : "Ungültige Eingabe!",
      "funnel" : {
        "funnel" : "Funnel",
        "chooseStep" : "Einen Schritt auswählen",
        "copyCodeAndOpenFunnel" : "Code kopieren und Funnel öffnen"
      },
      "share" : {
        "share" : "Teilen",
        "shareViaSocials" : "Via Soziale Medien teilen",
        "copyLink" : "Link kopieren"
      },
      "email" : {
        "email" : "E-Mail",
        "shareViaEmail" : "Via E-Mail teilen",
        "emailButton" : "E-Mail",
        "blankTemplate" : "Leere Vorlage",
        "emailMarketingTemplates" : "E-Mail Marketing Vorlagen",
        "or" : "Oder",
        "chooseTemplate" : "Wählen Sie aus Ihren Vorlagen",
        "continue" : "Weiter"
      }
    },
    "rating" : {
      "icon" : "Symbol",
      "iconAlignment" : "Alignment",
      "count" : "Anzahl",
      "lowestRating" : "Min Bewertung",
      "highestRating" : "Max.. Bewertung",
      "iconSelectedState" : "Symbol Ausgewählt Status",
      "iconUnselectedState" : "Symbol nicht ausgewählter Status",
      "rating" : "Bewertung",
      "ratingSettings" : "Bewertung",
      "calculationType" : {
        "calculationType" : "So archivieren Sie Bewertung in Benutzerdefiniert Felder",
        "calculationTypeTooltip" : "Wenn Sie eine Frequenz von etwas 4 von 5 Sternchen haben, bedeutet dies: - Abschließend: 4 Von 5 - Prozentsatz: 80 - Fraktion: 0,8",
        "absolute" : "Absicherung",
        "percentage" : "Prozentsatz",
        "fraction" : "Fraktion"
      }
    },
    "desktopMode" : "Desktop-Modus",
    "mobileMode" : "Mobiler Modus",
    "versions" : "Varianten",
    "advanced" : "Erweitert",
    "edit" : "Bearbeiten",
    "settings" : "Einstellungen",
    "submissions" : "Einreichungen",
    "undo" : "Rückgängig machen",
    "redo" : "Wiederholen",
    "customValues" : "Benutzerdefinierte Werte",
    "pickBgFromImage" : "Fügt dem Hintergrund Ihres Nachrichtenfelds einen Unschärfeeffekt hinzu. Wenn Sie eine Hintergrundfarbe für das Nachrichtenfeld auswählen, wird sie über dem verschwommenen Nachrichtenfeld angezeigt.",
    "pickBgFromImageTip" : "Wählt eine Farbe mit hohem Vergleichen für das BG-Bild aus. Nachricht: Wird nicht angewendet, falls der Formular Hintergrund kein Bild hat",
    "messageBackgroundBlur" : "Weichzeichner für Hintergrund",
    "confirmationMessage" : "Bestätigungsnachricht",
    "deleteOption" : "Option Löschen",
    "deleteConfirmationModal" : {
      "defaultDescription" : "Das Löschen einer Option wirkt sich auf dieses Benutzerdefiniert Feld auf allen Plätzen aus, an denen das Feld verwendet wird. Möchten Sie es wirklich löschen?",
      "validationMessage" : "Bitte geben Sie Löschen ein, um zu speichern.",
      "validationError" : "Bitte geben Sie Löschen ein"
    },
    "disqualifyImmediately" : "Sofort disqualifizieren",
    "disqualifyAfterSubmit" : "Nach dem Absenden disqualifizieren",
    "generalSettings" : "Allgemein Einstellungen",
    "advancedSettings" : "Erweiterte Einstellungen",
    "customFieldName" : "Benutzerdefinierter Name",
    "customFieldNameTooltip" : "Dieser Name ist eindeutig je Benutzerdefiniert Industrie.",
    "uniqueKey" : "Einzigartiger Schlüssel",
    "uniqueKeyTooltip" : "Dieser Schlüssel- ist eindeutig je Benutzerdefiniert Industrie.",
    "selectContactAssociation" : "Klicken Sie die Verknüpfung mit Kontakten aus",
    "associations" : "Verknüpfungen",
    "createNewAssociation" : "Neue Verknüpfung erstellen",
    "selectAnAssociation" : "Verknüpfung auswählen",
    "loadingAssociations" : "Assoziationen werden geladen...",
    "unknownAssociation" : "Anonyme Verknüpfung",
    "manyToMany" : "Viele-zu-Viele",
    "failedToLoadAssociations" : "Zuordnungen konnten nicht geladen werden",
    "noAssociationsFound" : "Keine Verknüpfungen gefunden",
    "keepThisField" : "Dieses Feld behalten",
    "association" : "Verknüpfungen",
    "customObject" : "Benutzerdefiniertes Objekt",
    "customObjects" : "Benutzerdefinierte Objekte",
    "object" : "Objekt",
    "editAssociation" : "{objectName} -Verknüpfung bearbeiten",
    "editAssociationButton" : "{edit} {objectName} {association}",
    "fields" : "Felder",
    "primaryFieldWarning" : "{fieldName} ist ein PRIMÄRES Feld für {objectSingular} und ist Erforderlich, um ein {objectSingular} zu erstellen Oder zu aktualisieren.",
    "primaryFieldTitle" : "{fieldName} ist Erforderlich, um das Dokument {objectSingular} zu erstellen oder zu aktualisieren.",
    "removeAllFields" : "Alle {objectSingular} Felder klären",
    "customObjectsFallback" : "Benutzerdefinierte Objekte",
    "noneAssociation" : "Nichts",
    "noneAssociationDescription" : "Keine Verknüpfung mit Kontakten (keine Kontaktfelder vorhanden)",
    "survey" : {
      "layoutType" : "Umfragetyp",
      "oneQuestionPerPage" : "Eine Frage nach der anderen",
      "allQuestionsOnePage" : "Mehrere auf einmal"
    },
    "quizQuestions" : "Quiz-Abfrage",
    "choiceElements" : "Wahl Komponenten",
    "otherElements" : "Andere Komponenten",
    "listEditor" : {
      "prefillValueHeader" : "Wert im Vorausfüllen",
      "labelPlaceholder" : "Label",
      "valuePlaceholder" : "Wert",
      "optionRequiredError" : "Die Option Feld ist erforderlich"
    },
    "field" : "Feld",
    "scoreEditor" : {
      "addFieldPlaceholder" : "Feld Hinzufügen",
      "fieldLabel" : "Feld",
      "numberLabel" : "Nummer"
    },
    "fileUploadEditor" : {
      "fileTypes" : "File",
      "all" : "jeder",
      "pdf" : "PDF",
      "docxDoc" : "DOC",
      "png" : "PNG",
      "gif" : "GIF",
      "jpgJpeg" : "JPG/ JPG",
      "xlsCsv" : "CSV"
    },
    "ok" : "Ok",
    "allowMultipleFiles" : "Mehrere Dateien aktivieren",
    "maxFileLimit" : "Max. File",
    "privacyPolicy" : "Datenschutzrichtlinien",
    "termsOfService" : "Bedingungen von Service",
    "colorPicker" : {
      "brandColors" : "Markenfarben",
      "defaultColors" : "Standardfarben",
      "globalCustomColors" : "Globale benutzerdefinierte Farben"
    },
    "billingFrequency" : "Abrechnungshäufigkeit",
    "otherAmount" : "Anderer Betrag",
    "exampleUrlPlaceholder" : "https://www.beispiel.de",
    "checkboxStyles" : {
      "standardAlt" : "Standard-Kontrollkästchen-Stil",
      "bubbleAlt" : "Bubble-Checkbox-Stil"
    },
    "previewIcons" : {
      "exportAlt" : "Symbol für Export",
      "shipmentAlt" : "Symbol für Versand",
      "resultAlt" : "Symbol für Ergebnisseite"
    },
    "examples" : {
      "sampleUrl" : "https://beispieldomain.de"
    },
    "showing" : "Anzeigen",
    "of" : "von",
    "enterCouponCode" : "Gutscheincode eingeben",
    "apply" : "Anwenden",
    "paymentWillBeProcessed" : "Die Zahlung wird verarbeitet, sobald Sie zum nächsten Schritt übergehen",
    "paymentWillBeProcessedNextSlide" : "Die Zahlung wird bearbeitet, sobald der Benutzer zur nächsten Folie weitergeht",
    "showThisAlertToUsers" : "Diese Warnung für Benutzer anzeigen",
    "sixteenDigitCardNumber" : "16-stellige Kartennummer",
    "mmYy" : "MM/JJ",
    "cvc" : "CVC",
    "pleaseFillRequiredFields" : "Bitte füllen Sie alle erforderlichen Felder aus!",
    "opportunitySettingsIncomplete" : "Opportunity-Einstellungen unvollständig",
    "opportunitySettingsIncompleteDescription" : "Dieses Formular enthält Opportunity-Felder, aber die Opportunity-Einstellungen wurden nicht aktualisiert. Bitte konfigurieren Sie erst die Opportunity-Einstellungen, um mit dem Speichern des Formulars fortzufahren.",
    "ariaAttributes" : {
      "iconSearch" : "Symbol-Suche"
    },
    "alt" : {
      "standardRadioStyle" : "Optionsfeld im Standard-Stil",
      "bubbleRadioStyle" : "Optionsfeld im Blasen-Stil"
    },
    "value" : "Wert",
    "jumpTo" : "Wechseln zu",
    "thankYouJohnDoe" : "Vielen Dank, John Doe",
    "total" : "Gesamt",
    "urlExamples" : {
      "simple" : "beispiel.de",
      "https" : "https://beispiel.de",
      "withPath" : "example.com/path",
      "fullPath" : "https://www.example.com/path"
    }
  },
  "fields" : {
    "quizQuestions" : {
      "singleChoice" : "Einzelperson Wahl",
      "multipleChoice" : "Mehrfachauswahl",
      "yesNo" : "Ja / Nein",
      "shortAnswer" : "Short-Video Beantwortet",
      "longAnswer" : "Länger beantwortet",
      "number" : "Nummer",
      "singleDropdown" : "Dropdown„Einwilligung“.",
      "multiDropdown" : "Multi Dropdown"
    },
    "personal" : {
      "fullName" : "Voll Name",
      "firstName" : "Vorname",
      "lastName" : "letzte Name",
      "dateOfBirth" : "Datum von Geburt",
      "phone" : "Telefon",
      "email" : "Gmail"
    },
    "submit" : {
      "button" : "Schaltfläche"
    },
    "integration" : {
      "sellProducts" : "Produkte verkaufen",
      "collectPayment" : "Ausschüttung einziehen"
    },
    "address" : {
      "address" : "Anschrift",
      "streetAddress" : "Anschrift",
      "city" : "Stadt",
      "state" : "Status",
      "country" : "Land",
      "postalCode" : "Code",
      "organization" : "Gruppe",
      "website" : "Website",
      "websitePlaceholder" : "Die Web-URL wird hier eingefügt"
    },
    "text" : {
      "singleLine" : "Einzelperson Linie",
      "multiLine" : "Linie",
      "textBoxList" : "Text Quadrat Liste"
    },
    "choiceElements" : {
      "singleDropdown" : "Dropdown„Einwilligung“.",
      "multiDropdown" : "Multi Dropdown",
      "checkbox" : "Kontrollkästchen",
      "radio" : "Radio"
    },
    "customized" : {
      "text" : "Klicken Sie, um diesen Text zu bearbeiten",
      "html" : "HTML",
      "htmlPlaceholder" : "Das Benutzerdefiniert HTML wird hier eingefügt",
      "captcha" : "Quittung",
      "source" : "Quelle",
      "termsAndConditions" : "T & C",
      "termsAndConditionsPlaceholder" : "Ich stimmte den allgemeinen Geschäftsbedingungen zu, die über das Unternehmen ausgestellt wurden. Via die Angaben deiner Rufnummer stimmte ich zu, Text vom Unternehmen zu senden.",
      "score" : "Bewertung"
    },
    "other" : {
      "image" : "Bild",
      "fileUpload" : "File Upload",
      "monetary" : "Monetär",
      "number" : "Nummer",
      "datePicker" : "Datum",
      "signature" : "Signatur"
    },
    "customstyle" : "Stil",
    "standard" : "Standard",
    "bubble" : "Blase"
  },
  "survey" : {
    "typeOfBuilder" : "Umfrage",
    "survyeStyle" : "Umfrage-Stil",
    "surveyName" : "Umfragename",
    "surveyElement" : "Umfrageelement",
    "addSurveyElement" : "Umfrageelement hinzufügen",
    "cloneSlide" : "Folie duplizieren",
    "unsavedAlertMessage" : "Die Umfrage enthält ungespeicherte Arbeit. Möchten Sie wirklich gehen und alle nicht gespeicherten Arbeiten verwerfen?",
    "thirdPartyScriptAlertMessage" : "Drittanbieter-Skripte innerhalb des HTML-Blocks können zwar leistungsstarke Funktionen bieten, bringen aber auch Risiken für Datenschutz, Sicherheit, Leistung und Seitenverhalten mit sich. Daher empfehlen wir, den Inhalt dieses Skripts zu überprüfen, bevor du es in der Umfrage speicherst.",
    "integrateHeader" : "Umfrage integrieren",
    "integrateSubHeader" : "Verwenden Sie die folgenden Optionen, um Ihre benutzerdefinierte Umfrage in Ihre Website zu integrieren",
    "integrateCopyLinkMessage" : "Kopieren Sie den unten stehenden Link und teilen Sie ihn ganz einfach, wo immer Sie möchten.",
    "onSurveySubmission" : "Bei Umfrageeinreichung",
    "surveySettings" : "Umfrage-Einstellungen",
    "oneQuestionAtTime" : "Eine Frage nach der anderen",
    "backButton" : "Schaltfläche „Zurück“",
    "backButtonTooltipMessage" : "Mit der Zurück-Schaltfläche können Benutzer zur vorherigen Folie zurückkehren",
    "disableAutoNavigation" : "Automatische Navigation deaktivieren",
    "disableAutoNavigationTooltipMessage" : "Navigiert automatisch zur nächsten Folie, später antwortet ein Benutzer.",
    "autoNavigation" : "Auto Navigation",
    "autoNavigationTooltipMessage" : "Navigiert automatisch zur nächsten Folie, später antwortet ein Benutzer.",
    "progressBar" : "Fortschrittsbalken",
    "progressBarTooltipMessage" : "Wenn diese Option deaktiviert wird, wird der Fortschrittsbalken aus der Umfrage entfernt",
    "disableAnimation" : "Animation ausschalten",
    "disableAnimationTooltipMessage" : "Wenn Sie diese Option aktivieren, wird die Animation des Folienübergangs deaktiviert.",
    "scrollToTop" : "Nach oben scrollen",
    "scrollToTopTooltipMessage" : "Wenn diese Option aktiviert ist, wird die Umfrage auf der nächsten Folie nach oben gescrollt",
    "submitSurvey" : "Umfrage absenden",
    "disqualifyImmediately" : "Sofort disqualifizieren",
    "disqualifyAfterSubmit" : "Nach dem Absenden disqualifizieren",
    "disqualifyAfterSubmitLowerCase" : "Nach dem Absenden disqualifizieren",
    "footerHTML" : "Fußzeile HTML",
    "footerHTMLMessage" : "Sie können benutzerdefiniertes CSS (unter Verwendung des style-Tags) und HTML innerhalb desselben Kastens schreiben",
    "editFooter" : "Fußzeile bearbeiten",
    "disqualifySettings" : "Einstellungen disqualifizieren",
    "disqualifyImmediatelyLabel" : "Sofort",
    "disqualifyAfterSubmitLabel" : "Nach dem Absenden",
    "slideConflictAlertMessage" : "Diese Folie enthält mehrere Fragen, für die eine Logik festgelegt ist. Dies kann zu unbeabsichtigtem Verhalten führen",
    "addSlide" : "Dia hinzufügen",
    "settings" : "Einstellungen",
    "delete" : "Löschen",
    "slideDeleteAlertMessage" : "Sind Sie sicher, dass Sie diese Folie löschen möchten?",
    "slideDeleteBetweenAlertMessage" : "Dadurch werden die anderen Folien neu angeordnet. Möchten Sie diese Folie wirklich löschen?",
    "slideLabel" : "Folie {n}",
    "slideName" : "Folienname",
    "slidePosition" : "Folienposition",
    "jumpTo" : "Springen zu",
    "jumpToSubText" : "Zu einer bestimmten Folie springen",
    "enableTimezoneSurvey" : "Wenn Sie diese Option aktivieren, werden die Zeitzoneninformationen der Person erfasst, die die Umfrage einreicht",
    "footer" : {
      "footer" : "Fußzeile",
      "enableNewFooter" : "Neuen Footer aktivieren",
      "stickToSurvey" : " Bei der Umfrage bleiben",
      "backgroundFill" : "Hintergrundfüllung",
      "footerHeight" : "Höhe der Fußzeile",
      "enableProgressBar" : "Fortschrittsbalken einschalten",
      "buttons" : "Buttons",
      "button" : "Schaltfläche",
      "buttonType" : "Button-Typ",
      "fillNext" : "Füllen (nächste)",
      "fillPrevious" : "Ausfüllen (vorherige)",
      "fillSubmit" : "Ausfüllen (Absenden)",
      "textColor" : "Schaltflächentext",
      "position" : "Position",
      "previousText" : "Vorherige (Text)",
      "nextText" : "Weiter (Text)",
      "submitText" : "Einreichen (Text)",
      "fillComplete" : "Ausfüllen abgeschlossen",
      "fillInactive" : "Inaktive ausfüllen",
      "footerType" : "Art der Fußzeile",
      "stickToCard" : "An Karte halten",
      "stickToPage" : "Seite beibehalten",
      "stepTextColor" : "Schritt Textkörperfarbe",
      "progressBarFill" : "Fortschrittsbalken füllen",
      "progressBarInactive" : "Fortschrittsbalken Inaktiv",
      "arrowFill" : "Pfeil füllen",
      "submitColorMobile" : "Absenden (Farbe)",
      "arrowFillColor" : "Pfeil füllen Farbe",
      "buttonTypes" : {
        "textAndArrow" : "Text & Pfeil",
        "onlyText" : "Nur Text",
        "onlyArrow" : "Nur Pfeil"
      },
      "positions" : {
        "leftAndRight" : "Links & Rechts"
      },
      "placeholders" : {
        "prev" : "Zurück",
        "next" : "Weiter",
        "submit" : "Absenden"
      }
    },
    "surveyNotfication" : "Umfrage-Benachrichtigung",
    "style" : {
      "surveyPadding" : "Padding für Umfragen"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Umfrage einbetten oder teilen",
      "share" : {
        "openFormLink" : "Öffnen den Umfrage Link"
      },
      "email" : {
        "emailSubheader" : "Erstellen Sie eine leer E-Mail und binden Sie Ihre Umfrage ein, oder wählen Sie eine Vorlage aus und binden Sie sie unmittelbar."
      }
    },
    "autoResponderSubheader" : "Senden Sie eine automatisierte E-Mail an die Person, die die Umfrage einreicht (die E-Mail enthält eine Kopie der Informationen, die sie in der Umfrage eingegeben hat)",
    "sendSubmissionsAsPdf" : "Umfrage als PDF senden",
    "switchToOneQuestionAtTimeOn" : "Durch die Aktivierung von „ Eine Frage an einem Datum“ wird Ihre derzeit bedingte Logik unterbrochen",
    "switchToOneQuestionAtTimeOff" : "Das Deaktivieren von „ Eine Frage an einem Datum“ wirkt sich auf Ihre bedingte Logik Konfig aus",
    "switchToOneQuestionAtTimeOnWarning" : "Einige Bedingungen funktionieren nicht mehr wie erwartet, wenn Fragen an einem Datum Erschienen sind.",
    "switchToOneQuestionAtTimeOffWarning" : " Einige Bedingungen, die für Einzelperson-frage fließen, funktionieren nicht mehr wie vorgesehen.",
    "createContactOnPartialSubmissionSubText" : "Erstellt einen Kontakt, wenn ein Benutzer auf einer beliebigen Folie auf „Weiter“ klickt, selbst wenn er die Umfrage nicht abschließt.",
    "dragDrop" : {
      "imageLabel" : "Bild {n}",
      "htmlLabel" : "HTML {n}",
      "defaultFolderName" : "Umfrage {'|'} {name}",
      "defaultTermsHtml" : "<p style=\"text-align: center\"><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Datenschutzrichtlinie</a> | <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Nutzungsbedingungen</a></p>",
      "smsConsent" : "Ich stimme zu, Benachrichtigungen, Warnungen und gelegentliche Marketingkommunikation per SMS vom Unternehmen zu erhalten. Häufigkeit der Nachrichten variiert. Es können Gebühren für Nachrichten und die Datenübertragung anfallen. Senden Sie eine SMS mit dem Text HELP an (XXX) XXX-XXXX, um Unterstützung zu erhalten. Sie können jederzeit mit STOP antworten, um sich abzumelden."
    }
  },
  "form" : {
    "typeOfBuilder" : "Formular",
    "formStyle" : "Formularstil",
    "formElement" : "Formularelement",
    "addFormElement" : "Formularelement hinzufügen",
    "addConditionalLogic" : "Bedingte Logik hinzufügen",
    "openConditionalLogic" : "Bedingte Logik öffnen",
    "inlineForm" : "Inline-Formular",
    "formName" : "Formularname",
    "fullScreenMode" : "Vollbildmodus",
    "fullScreenModetooltip" : "Wenn Sie die Funktion einschalten, wird das Formular über die gesamte Breite seines Containers erweitert und erstreckt sich bis zum Rand des Einbettungsbereichs, während es die Breite des Formulars beibehält.",
    "enableTimezoneForm" : "Durch Aktivieren dieser Option werden die Zeitzoneninformationen der Person erfasst, die das Formular einreicht.",
    "formSettings" : "Formulareinstellungen",
    "unsavedAlertMessage" : "Das Formular enthält ungespeicherte Arbeit. Möchten Sie wirklich gehen und alle nicht gespeicherten Arbeiten verwerfen?",
    "thirdPartyScriptAlertMessage" : "Drittanbieter-Skripte innerhalb des HTML-Blocks können zwar leistungsstarke Funktionen bieten, bringen aber auch Risiken für Datenschutz, Sicherheit, Leistung und Seitenverhalten mit sich. Daher empfehlen wir Ihnen, den Inhalt dieses Skripts zu überprüfen, bevor Sie es im Formular speichern.",
    "onFormSubmission" : "Bei der Einreichung des Formulars",
    "integrateForm" : "Formular integrieren",
    "embedlayoutType" : "Einbinden Layout eintippen",
    "embedlayoutTypeSubMessage" : "Wählen Sie ein Layout aus, das in einen Funnel oder eine externe Website eingebettet werden soll",
    "triggerType" : "Auslöser-Typ",
    "showOnScrolling" : "Beim Scrollen anzeigen",
    "showAfter" : "Anzeigen nach",
    "seconds" : "Sekunden",
    "alwaysShow" : "Immer anzeigen",
    "activationOptions" : "Aktivierungsoptionen",
    "activateOn" : "Aktivieren am",
    "visit" : "Besuchen",
    "alwaysActivated" : "Immer aktiviert",
    "deactivationOptions" : "Deaktivierungsoptionen",
    "deactivateAfterShowing" : "Nach dem Anzeigen deaktivieren",
    "times" : "Mal",
    "deactiveOnceLeadCollected" : "Deaktivieren, sobald der Lead erfasst wurde",
    "neverDeactivate" : "Niemals deaktivieren",
    "copyEmbedCode" : "Einbettungscode kopieren",
    "copyFormLink" : "Formularlink kopieren",
    "openFormLink" : "Link zum Formular öffnen",
    "inline" : "Inline",
    "inlineDescription" : "Ein Inline-Formular wird zusammen mit dem Inhalt der Seite als natives Element angezeigt. Es überlagert sich nicht und kann nicht geschlossen oder minimiert werden.",
    "inlineHoverDescription" : "Ein Inline-Formular wird zusammen mit dem Inhalt der Seite als natives Element angezeigt. Es überlagert sich nicht und kann nicht geschlossen oder minimiert werden.",
    "popup" : "Pop-up",
    "popupDescription" : "Ein Pop-up zeigt ein Formular als Overlay in einem Leuchtkasten an. Sie kann nicht minimiert, sondern nur geschlossen werden.",
    "popupHoverDescription" : "Ein Pop-up zeigt ein Formular als Overlay in einem Leuchtkasten an. Sie kann nicht minimiert, sondern nur geschlossen werden.",
    "politeSlideIn" : "Höfliches Einschieben",
    "politeSlideInDescription" : "Ein höflicher Einschub erscheint an der Unterseite des Bildschirms und verschwindet nach dem Schließen",
    "politeSlideInHoverDescription" : "Erscheint auf der Unterseite des Bildschirms und verschwindet nach dem Schließen",
    "stickySidebar" : "Klebrige Seitenleiste",
    "stickySidebarDescription" : "Eine Sticky-Seitenleiste wird an der Seite des Bildschirms angezeigt und kann auf einen Tab minimiert werden, der an der Seite des Fensters haftet",
    "stickySidebarHoverDescription" : "Erscheint an der Seite des Bildschirms und kann auf eine Registerkarte minimiert werden, die an der Seite des Fensters klebt",
    "allowMinimize" : "Minimieren zulassen",
    "conditonalLogic" : {
      "conditions" : "Bedingungen",
      "noExistingCondition" : "Noch keine bestehenden Bedingungen",
      "freeRoamMessage" : "Du kannst dich frei bewegen, ohne Regeln – zumindest im Moment",
      "addNewCondition" : "Neue Bedingung hinzufügen",
      "redirectToUrl" : "Weiterleitung auf URL",
      "displayCustomMessage" : "Benutzerdefinierte Nachricht anzeigen",
      "disqualifyLead" : "Lead disqualifizieren",
      "showHideFields" : "Felder ein-/ausblenden",
      "jumpTo" : "Wechseln zu",
      "redirectToUrlSubText" : "Leiten Sie Benutzer nach der Einreichung um",
      "displayCustomMessageSubText" : "Nachrichten basierend auf den Eingaben eines Benutzers anzeigen",
      "disqualifyLeadSubText" : "Filter Einträge unter bestimmten Bedingungen heraus",
      "showHideFieldsSubText" : "Feld Sichtbarkeit synchron ändern",
      "openBelowUrl" : "Öffnen Sie die folgende URL",
      "showCustomMessage" : "Benutzerdefinierte Nachricht anzeigen",
      "alertConditionDelete" : "Bist du sicher, dass du diese Bedingung löschen möchtest?",
      "deleteCondition" : "Bedingung löschen",
      "conditionExecutedMessage" : "Bedingungen werden in Top-Down-Reihenfolge ausgeführt.",
      "allOperationOptions" : {
        "isEqualTo" : "Ist gleich",
        "isNotEqualTo" : "Ist nicht gleich",
        "contains" : "Enthält",
        "doesNotContain" : "Enthält nicht",
        "startsWith" : "Beginnt mit",
        "endsWith" : "Endet mit",
        "isEmpty" : "Ist leer",
        "isFilled" : "Ist gefüllt",
        "before" : "Vorher",
        "after" : "Nach",
        "greaterThan" : "Größer als",
        "lessThan" : "Weniger als",
        "between" : "Zwischen",
        "isChecked" : "Ist überprüft",
        "isNotChecked" : "Ist nicht überprüft"
      },
      "logic" : {
        "if" : "Wenn",
        "then" : "Dann",
        "and" : "Und",
        "or" : "Oder"
      },
      "phoneAlertMessage" : "Um nach Telefonnummern mit einer Landesvorwahl zu suchen, musst du das \"+\"-Symbol ausdrücklich in deine Suchanfrage aufnehmen.",
      "deleteAlertMessage" : "Bist du sicher, dass du dieses Feld löschen möchtest? Die mit diesem Feld verknüpfte Bedingung wird ebenfalls entfernt.",
      "deleteField" : "Feld löschen",
      "jumpToDescription" : "Springen Sie zu einer bestimmten Folie, wenn die Bedingungen erfüllt sind",
      "cycleError" : "Speichern nicht möglich. Loop zwischen {a} und {b}erkannt.",
      "jumpToSlide" : "Zur Folie springen",
      "submitSurvey" : "Umfrage Speichern",
      "pageTitle" : "P{index} – {title}",
      "selectSlideToJumpTo" : "Wählen Sie die Folie aus, von der Sie springen möchten",
      "selectedSlide" : "Ausgewählte Folie",
      "typeValueHere" : "Bitte tippen Sie hier einen Wert ein.",
      "field" : "Feld",
      "slide" : "Folie",
      "selectFieldOrSlide" : "Feld oder Folie auswählen",
      "selectFieldState" : "Feldstatus auswählen",
      "selectField" : "Feld auswählen",
      "selectOption" : "Option auswählen",
      "jumpToTarget" : "Springen zu",
      "jumpToQuestion" : "Zur Frage springen",
      "chooseQuestion" : "Frage auswählen",
      "includeStart" : "Start einbeziehen",
      "includeEnd" : "Ende einbeziehen",
      "includeValue" : "{value}einbeziehen",
      "hideField" : "Feld ausblenden",
      "hideFields" : "Felder ausblenden",
      "showField" : "Feld anzeigen",
      "showFields" : "Felder anzeigen",
      "additionalRulesPrefix" : "… und",
      "additionalRulesSuffix" : "andere {ifLabel} Regeln …",
      "shownTargetsWithMore" : "{shown}, +{count} mehr",
      "noConditionsAlt" : "Noch keine Bedingungen",
      "outcomeLabels" : {
        "show" : "Anzeigen",
        "jumpTo" : "Wechseln zu"
      }
    },
    "minimizedTitlePlaceholder" : "Minimierter Titel",
    "dragYourElementFromLeft" : "Ziehen Sie Ihre Elemente von links hierher",
    "formNotification" : "Benachrichtigung per Formular",
    "sendSubmissionsAsPdf" : "Formulareinreichung als PDF senden",
    "style" : {
      "formPadding" : "Formular-Padding"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Formular einbetten oder teilen",
      "share" : {
        "openFormLink" : "Link zum Formular Öffnen"
      },
      "email" : {
        "emailSubheader" : "Erstellen Sie eine leer E-Mail und binden Sie Ihr Formular ein, oder wählen Sie eine Vorlage aus und binden Sie sie unmittelbar."
      }
    },
    "choosePosition" : "Auswählen Status",
    "testBuild" : "Test-Build"
  },
  "quiz" : {
    "quizElement" : "Quiz-Element",
    "quizNotification" : "Quiz-Benachrichtigung",
    "viewAndCustomise" : "Anzeigen und Anpassen",
    "categoryAndScore" : "Kategorie und Punktzahl",
    "provideFeedback" : "Feedback geben",
    "addQuizElement" : "Quiz-Element hinzufügen",
    "typeOfBuilder" : "Quiz",
    "addQuestions" : "Fragen Hinzufügen",
    "dragAndDropQuestion" : "Ziehen Sie ein Frage hier.",
    "addNewPage" : "Neue Seite hinzufügen",
    "editTemplate" : "Vorlage Bearbeiten",
    "editResultPage" : "Ergebnisseite bearbeiten",
    "clonePage" : "Seite Klonen",
    "category" : {
      "category" : "Kategorie",
      "watchVideo" : "Schau dir dieses Video an, um mehr zu erfahren. Über wie die Kategorie die Ergebnisseite beeinflusst!",
      "useCategoryWhen" : "Verwenden Sie Kategorien, wenn",
      "manageCategories" : "Kategorien Verwalten",
      "howItWorks" : "Wie funktioniert das?",
      "howItWorks2" : "Wie funktioniert das",
      "addCategoryMessage" : "Hinzufügen eine Neu Kategorie hinzu",
      "assignCategoryMessage" : "Weise jeder Option eine Kategorie zu",
      "editResultsMessage" : "Kategorie-Score in der Ergebnisseite anzeigen",
      "addCategory" : "Kategorie Hinzufügen",
      "deleteCategoryAlertMessage" : "Löschen einer Kategorie wird das Ergebnis von dieser Kategorie in allen Optionen gelöscht",
      "editOrAddNewCategories" : "Sie können neue Kategorien bearbeiten oder einbeziehen",
      "toEvaluateTheResponder" : "Zum Vergleichen des Antwortanbieters basierend auf mehreren Faktoren",
      "showMultipleCategoryScore" : "Mehrere Kategorie-Score in der Ergebnisseite anzeigen",
      "displayVaryingContent" : "Display variierenden Inhalt auf der Ergebnisseite an, je nach Kategorie-Score-Reihe",
      "theOptionFieldIsRequired" : "Das Optionsfeld ist ein Pflichtfeld",
      "addManage" : "Hinzufügen / Verwalten",
      "enterCategoryPlaceholder" : "Kategorienamen eingeben",
      "carouselAlt" : "Kategorie-Vorschau-Folie"
    },
    "quizSettings" : "Quiz-Einstellungen",
    "onQuizSubmission" : "Bei der Quiz-Einreichung",
    "settings" : "Einstellungen",
    "deletePage" : "Seite löschen",
    "quizResult" : {
      "resultTemplate" : "Ergebnisvorlage",
      "quizResultAlertMessage" : "Die ausgewählte Ergebnisseite wird angezeigt, sobald das Quiz abgeschlossen ist",
      "overallScoreLabel" : "Gesamtbewertung"
    },
    "autoResponderSubheader" : "Senden Sie eine automatische E-Mail an die Person, die das Quiz eingereicht hat (E-Mail enthält eine Kopie der Informationen, die sie in das Quiz eingegeben hat)",
    "sendSubmissionsAsPdf" : "Quiz-Einreichung als PDF senden",
    "sendQuizResultsAsPdf" : "Quiz-Ergebnis als PDF senden",
    "integrateHeader" : "Quiz integrieren",
    "integrateSubHeader" : "Verwenden Sie die folgenden Optionen, um Ihr individuelles Quiz in Ihre Website zu integrieren",
    "integrateCopyLinkMessage" : "Kopieren Sie den unten stehenden Link und teilen Sie ihn einfach, wo immer Sie möchten.",
    "pageLabel" : "Seite {n}",
    "pageName" : "Seitenname",
    "pagePosition" : "Seitenposition",
    "createContactOnPartialSubmissionSubText" : "Erstellt einen Kontakt, wenn ein Benutzer auf einer beliebigen Folie auf „Weiter“ klickt, auch wenn er das Quiz nicht abschließt.",
    "integratePopup" : {
      "shareOrEmbed" : "Quiz einbetten oder teilen",
      "share" : {
        "openFormLink" : "Öffnen den Quiz- Link"
      },
      "email" : {
        "emailSubheader" : "Erstellen Sie eine freie E-Mail und binden Sie Ihr Quiz ein, oder wählen Sie eine Vorlage aus und binden Sie sie unmittelbar."
      }
    }
  },
  "textEditor" : {
    "textAlign" : "Textausrichtung",
    "list" : "Liste",
    "sourceCode" : "Quellcode",
    "resetStyle" : "Stil zurücksetzen",
    "resetDocumentStyle" : "Dokumentenstil zurücksetzen"
  }
}
